if (!customElements.get('diwali-made-to-be-gifted')) {
  customElements.define('diwali-made-to-be-gifted', class extends HTMLElement {
    connectedCallback() {
      this.cards = [...this.querySelectorAll('.diwali-gifted__card')];
      this.mobile = matchMedia('(max-width: 749px)');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.refresh = () => this.configure();
      this.schedule = () => {
        if (!this.enabled || !this.visible || this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          this.render();
        });
      };
      this.select = event => {
        this.selected = event.target.closest('.diwali-gifted__card');
        this.render();
      };
      this.deselect = () => {
        this.selected = null;
        this.render();
      };
      if (!('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.schedule();
      }, { rootMargin: '100px' });
      this.observer.observe(this);
      this.mobile.addEventListener('change', this.refresh);
      this.reduced.addEventListener('change', this.refresh);
      window.addEventListener('scroll', this.schedule, { passive: true });
      window.addEventListener('resize', this.refresh, { passive: true });
      this.addEventListener('shopify:block:select', this.select);
      this.addEventListener('shopify:block:deselect', this.deselect);
      this.configure();
    }

    configure() {
      this.enabled = this.mobile.matches && !this.reduced.matches && this.dataset.motion === 'true';
      this.classList.toggle('is-motion', this.enabled);
      if (this.enabled) this.render();
      else this.cards.forEach(card => {
        ['--dg-lift', '--dg-opacity', '--dg-image-shift'].forEach(name => card.style.removeProperty(name));
      });
    }

    render() {
      if (!this.enabled) return;
      const height = window.innerHeight;
      this.cards.forEach(card => {
        const bounds = (card.parentElement || card).getBoundingClientRect();
        const progress = Math.max(0, Math.min(1, (height * 0.94 - bounds.top) / (height * 0.26)));
        const ease = progress * progress * (3 - 2 * progress);
        const shift = Math.max(-6, Math.min(6, ((bounds.top + bounds.height / 2) / height - 0.5) * 12));
        const selected = card === this.selected;
        card.style.setProperty('--dg-lift', selected ? '0' : String(24 * (1 - ease)));
        card.style.setProperty('--dg-opacity', selected ? '1' : String(0.78 + 0.22 * ease));
        card.style.setProperty('--dg-image-shift', selected ? '0' : String(shift));
      });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.mobile?.removeEventListener('change', this.refresh);
      this.reduced?.removeEventListener('change', this.refresh);
      window.removeEventListener('scroll', this.schedule);
      window.removeEventListener('resize', this.refresh);
      this.removeEventListener('shopify:block:select', this.select);
      this.removeEventListener('shopify:block:deselect', this.deselect);
      cancelAnimationFrame(this.frame);
    }
  });
}
